import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { appStorage } from '@sternum/web/services/appStorage';

export interface WorkloadsState {
  isOverviewAlertsSummaryAccordionExpanded: boolean;
  isAlertsFiltersSidebarOpen: boolean;
  areAlertNotesVisible: boolean;
  searchValue: string;
  isPollingAlerts: boolean;
}

const initialState: WorkloadsState = {
  isOverviewAlertsSummaryAccordionExpanded: true,
  isAlertsFiltersSidebarOpen: appStorage.workloads.getIsAlertsFiltersSidebarOpen() ?? true,
  searchValue: '',
  areAlertNotesVisible: appStorage.workloads.getAreAlertNotesVisible() ?? false,
  isPollingAlerts: appStorage.workloads.getIsAlertsPolling() ?? false,
};

export const workloadsSlice = createSlice({
  name: 'workloads',
  initialState,
  reducers: {
    toggleAreAlertNotesVisible(state) {
      state.areAlertNotesVisible = !state.areAlertNotesVisible;
    },
    closeAlertNotes(state) {
      state.areAlertNotesVisible = false;
    },

    togglePollingAlertsAction(state) {
      state.isPollingAlerts = !state.isPollingAlerts;
      appStorage.workloads.setIsAlertsPolling(state.isPollingAlerts);
    },

    stopPollingAlertsAction(state) {
      state.isPollingAlerts = false;
      appStorage.workloads.setIsAlertsPolling(state.isPollingAlerts);
    },

    setIsOverviewAlertsSummaryAccordionExpandedAction(state, action: PayloadAction<boolean>) {
      state.isOverviewAlertsSummaryAccordionExpanded = action.payload;
    },

    setIsAlertsFiltersSidebarOpenAction(state, action: PayloadAction<boolean>) {
      state.isAlertsFiltersSidebarOpen = action.payload;
    },

    toggleIsAlertsFiltersSidebarOpenAction(state) {
      state.isAlertsFiltersSidebarOpen = !state.isAlertsFiltersSidebarOpen;
    },

    setSearchValueAction(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },

    clearAlertsState() {
      return initialState;
    },
  },
});

export const {
  togglePollingAlertsAction,
  stopPollingAlertsAction,
  setIsOverviewAlertsSummaryAccordionExpandedAction,
  setIsAlertsFiltersSidebarOpenAction,
  toggleIsAlertsFiltersSidebarOpenAction,
  clearAlertsState,
  setSearchValueAction,
  toggleAreAlertNotesVisible,
  closeAlertNotes,
} = workloadsSlice.actions;
